import { NEW_HOST_URL } from "../../config/envConfig";
import { fetch } from "../../utils";

export const getDashBoardStates = (data) =>
  fetch(`${NEW_HOST_URL}/streams/states`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("authToken"),
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });

export const getVideoListStates = (data) =>
  fetch(`${NEW_HOST_URL}/streams/get`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("authToken"),
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });

export const getForgotPasswords = (data) => {
  return fetch(`${NEW_HOST_URL}/fogot_password`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });
};

export const resetPassword = (data) =>
  fetch(`${NEW_HOST_URL}/reset_password`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });

export const getChartData = ({ startDate, endDate, entityId }) =>
  fetch(`${NEW_HOST_URL}/dash-storage?startDate=${startDate}&endDate=${endDate}&entityId=${entityId}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("authToken"),
    },
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });
export const getIllustoStorageChartData = ({ startDate, endDate, entityId }) =>
  fetch(`${NEW_HOST_URL}/api/v3/dash-illustostorage?startDate=${startDate}&endDate=${endDate}&entityId=${entityId}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("authToken"),
    },
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });
export const getStreamStates = (data) =>
  fetch(`${NEW_HOST_URL}/streams/states`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("authToken"),
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });
export const analyticsToken = (data) =>
  fetch(`${NEW_HOST_URL}/analytics-token`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("authToken"),
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });

export const getCSVReport = (data) =>
  fetch(`${NEW_HOST_URL}/stream-highlights-clip-csv`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("authToken"),
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });
